import { Data, Model, Utils } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../DomainTypes';
import DashboardLookup from '../Models/Dashboard/DashboardLookup';
import DashboardNoteCriteria from '../Models/Dashboard/DashboardNoteCriteria';
import DashboardNoteLookup from '../Models/Dashboard/DashboardNoteLookup';
import SystemNoteLookup from '../Models/Catalogue/Reporting/Lookups/SystemNoteLookup';

export interface IDashboardApiClient {

    /** 
     * Gets the dashboard data.
     */
    getDashboardData(): AxiosPromise<Model.PlainObject<DashboardLookup>>;

    /** 
     * Gets a paged list of notes that have a reminder date, but are not yet completed
     */
    getReminderNotesPaged(request: Model.PartialPlainNonTrackedObject<Data.PageRequest<DashboardNoteCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<DashboardNoteLookup>>>;

    /** 
     * Completes the note with the given note id
     * @param noteId The note id of the note to complete
     */
    completeNote(noteId: number): AxiosPromise;

    /** 
     * Fetches the details for the system note with the given note id.
     * @param noteId The note id of the note to complete
     */
    getSystemNote(noteId: number): AxiosPromise<Model.PlainObject<SystemNoteLookup>>;

    /** 
     * Completes the system note with the given note id
     * @param noteId The note id of the note to complete
     */
    completeSystemNote(noteId: number): AxiosPromise;

    // Client only properties / methods
}

@injectable()
export default class DashboardApiClient extends Data.ApiClientBase implements IDashboardApiClient {

    constructor (config = AppService.get(Types.App.Config)) {
        super(`${config.apiPath}/dashboard`);
    }

    public getDashboardData(): AxiosPromise<Model.PlainObject<DashboardLookup>> {
        return this.axios.get(`${this.apiPath}`);
    }

    public getReminderNotesPaged(request: Model.PartialPlainNonTrackedObject<Data.PageRequest<DashboardNoteCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<DashboardNoteLookup>>> {
        return this.axios.get(`${this.apiPath}/reminder-notes-paged?${Utils.getQueryString(request)}`);
    }

    public completeNote(noteId: number): AxiosPromise {
        return this.axios.post(`${this.apiPath}/complete-note/${noteId}`);
    }

    public getSystemNote(noteId: number): AxiosPromise<Model.PlainObject<SystemNoteLookup>> {
        return this.axios.get(`${this.apiPath}/system-note/${noteId}`);
    }

    public completeSystemNote(noteId: number): AxiosPromise {
        return this.axios.post(`${this.apiPath}/complete-system-note/${noteId}`);
    }

    // Client only properties / methods
}